// api.js — all requests include x-user-id header from Clerk

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function getUserId() {
  return window.__clerk_user_id || 'default';
}

async function request(method, path, body, isFormData = false) {
  const headers = isFormData
    ? { 'x-user-id': getUserId() }
    : { 'Content-Type': 'application/json', 'x-user-id': getUserId() };

  const opts = {
    method,
    headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  };

  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.message || data.error || `HTTP ${res.status}`);
    err.code = data.error; // preserve 'upgrade_required'
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  uploadAudio: (file, title, emails = []) => {
    const form = new FormData();
    form.append('audio', file);
    if (title) form.append('title', title);
    if (emails.length) form.append('emails', emails.join(','));
    return request('POST', '/api/meetings/upload', form, true);
  },
  submitTranscript: (transcript, title, emails = []) =>
    request('POST', '/api/meetings/transcript', { transcript, title, emails }),
  getStatus:        (id) => request('GET', `/api/meetings/${id}/status`),
  getMeeting:       (id) => request('GET', `/api/meetings/${id}`),
  listMeetings:     (q)  => request('GET', `/api/meetings${q ? `?q=${encodeURIComponent(q)}` : ''}`),
  updateActionItem: (meetingId, itemId, updates) =>
    request('PATCH', `/api/meetings/${meetingId}/action-items/${itemId}`, updates),
  deleteMeeting:    (id) => request('DELETE', `/api/meetings/${id}`),
  sendEmail:        (id, emails) => request('POST', `/api/meetings/${id}/email`, { emails }),
  getPdfUrl:        (id) => `${BASE}/api/meetings/${id}/pdf`,
  health:           ()  => request('GET', '/api/health'),
};
